// Admin gate. This is a UI convenience only — the authoritative check is in the
// upsertExamProfile callable (which re-checks the admin claim) and the setAdminRole
// callable. A non-admin who reaches the admin page anyway cannot write exam
// profiles: the rules deny direct writes and the callable rejects non-admins.

import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AdminRoute() {
  const { user, isAdmin, loading } = useAuth();
  if (loading) return <div className="loading">Authenticating…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
